import { render, staticRenderFns } from "./shipping-and-deliveries.vue?vue&type=template&id=19e1231b&scoped=true&"
import script from "./shipping-and-deliveries.vue?vue&type=script&lang=js&"
export * from "./shipping-and-deliveries.vue?vue&type=script&lang=js&"
import style0 from "./shipping-and-deliveries.vue?vue&type=style&index=0&id=19e1231b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1231b",
  null
  
)

export default component.exports